module.exports = __webpack_public_path__ + "static/media/1 Blue'.1e2cbaee.svg";